// Third party
import { ErrorPolicy } from '@apollo/client';

// Utils
import {
  OrderLoadMutation,
  OrderLoadDocument,
  OrderLoadMutationVariables,
} from '@gql';
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables: OrderLoadMutationVariables;
  errorPolicy?: ErrorPolicy;
};

export const imperativeNodeOrderLoadMutation = async (
  options: Options,
  accessToken?: string
) => {
  let apolloClient = createApolloClient();

  if (accessToken) {
    apolloClient = createApolloClient(accessToken);
  }

  const response = await apolloClient.mutate<OrderLoadMutation>({
    ...{ mutation: OrderLoadDocument },
    ...options,
  });

  return { ...response, apolloClient };
};

// Union of all listingById types
type OrderLoadMutationResults = NonNullable<OrderLoadMutation['orderLoad']>;

// Get the branch of the order union that has a specific typename
type OrderLoadMutationResultsType<
  T extends OrderLoadMutationResults['__typename'],
> = OrderLoadMutationResults & { __typename: T };

export type OrderByIdPartial = OrderLoadMutationResultsType<'Order'>;
